import accountApiService from "./accountApiService.js";
import alertsApiService from "./alertsApiService.js";
import authApiService from "./authApiService.js";
import blillingApiService from "./blillingApiService.js";
import clientsApiService from "./clientsApiService.js";
import customersApiService from "./customersApiService.js";
import homeApiService from "./homeApiService.js";
import productsApiService from "./productsApiService.js";
import rolesApiService from "./rolesApiService.js";
import scheduledCheckInsApiService from "./scheduledCheckInsApiService.js";
import serviceCategoriesApiService from "./serviceCategoriesApiService.js";
import serviceOrdersApiService from "./serviceOrdersApiService.js";
import settingsApiService from "./settingsApiService.js";
import tattlesApiService from "./tattlesApiService.js";
import tripsApiService from "./tripsApiService.js";
import trucksApiService from "./trucksApiService.js";
import usersApiService from "./usersApiService.js";
import utilityApiService from "./utilityApiService.js";
import workOrdersApiService from "./workOrdersApiService.js";
import scheduledOrdersApiService from "./scheduledOrdersApiService.js";
import fileStorageService from "./fileStorageService.js";

//-----------------------------------------//
const apiService = {
  account: accountApiService,
  alerts: alertsApiService,
  auth: authApiService,
  billing: blillingApiService,
  clients: clientsApiService,
  customers: customersApiService,
  home: homeApiService,
  products: productsApiService,
  roles: rolesApiService,
  scheduledCheckIns: scheduledCheckInsApiService,
  serviceCategories: serviceCategoriesApiService,
  serviceOrders: serviceOrdersApiService,
  settings: settingsApiService,
  tattles: tattlesApiService,
  trips: tripsApiService,
  trucks: trucksApiService,
  users: usersApiService,
  utility: utilityApiService,
  workOrders: workOrdersApiService,
  scheduledOrders: scheduledOrdersApiService,
  fileStorage: fileStorageService,
};

export default apiService;
//-----------------------------------------//
